import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DictionaryEntry } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AddCatalogNode } from '../../catalog.model';

@Component({
  selector: 'app-add-catalog-node-dialog',
  templateUrl: './add-catalog-node-dialog.component.html',
  styleUrls: ['./add-catalog-node-dialog.component.scss']
})
export class AddCatalogNodeDialogComponent implements OnInit {

  name = new DictionaryEntry();

  catalogId: number;
  parentNodeId: number;

  constructor(
    public dialogRef: MatDialogRef<AddCatalogNodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI
  ) {

    this.catalogId = data.catalogId;
    this.parentNodeId = data.parentNodeId;

    console.log('dialog initialized with', this.catalogId, this.parentNodeId);
  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.appServerAPI.execute<number>('/client/erp-article/catalog/addCatalogNode',
      new AddCatalogNode({ catalogId: this.catalogId, parentNodeId: this.parentNodeId, name: this.name }))
      .subscribe(response => {

        console.log('response is', response);

        this.dialogRef.close();

      }, error => {
        console.log('error is', error);
      });
  }

  confirmDisabled(): boolean {
    return this.name == null || this.name.values == null || this.name.values.length === 0 || !this.name.checkValueExistsForLanguage('de');
  }

  public onNameChanged(dictionary: DictionaryEntry) {
    this.name = new DictionaryEntry(dictionary);
  }

}
